import {Injectable} from "@angular/core";
import {DxAuthenticationStrategy} from "./dx-authentication-strategy";
import {Observable, of} from "rxjs/index";
import {DxAuthentication} from "../../../domain/authentication/dx-athentication";
import {DxHttpDispatcher} from "../../../../dx-core/services/dx-http-dispatcher.service";
import {DxEncryptionService} from "../../../../dx-core/services/dx-encryption.service";
import {DxObjectMapper} from "../../../../dx-core/services/dx-object-mapper.service";
import {Router, UrlTree} from "@angular/router";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {catchError, switchMap} from "rxjs/operators";
import {HttpHeaders, HttpParams} from "@angular/common/http";
import {DxSessionService} from "../../dx-session.service";
import {DxRequestOptions} from "../../../../dx-core/domain/http/dx-request-options";
import {LocationUtils} from "../../../../dx-core/utiles/location-utils";
import {environment} from "../../../../../environments/environment";


/**
 * Стратегия аунтификации пользователя при помощи сервиса авторизации.
 * @publicApi
 */
@Injectable()
export class DxServerDefinedAuthenticationStrategy implements DxAuthenticationStrategy {


  constructor(private _http: DxHttpDispatcher,
              private _router: Router,
              private _configService: BdpkConfigService,
              private sessionService: DxSessionService,
              private _mapper: DxObjectMapper,
              private _encryptor: DxEncryptionService) {
  }


  public authenticate(login: string, password: string): Observable<DxAuthentication> {

    const returnurl = LocationUtils.getBaseURI() + '/navigator/tasks';

    const url = environment.stand === 'local' ?
      this._router.createUrlTree([environment.backend.rsaaOAuth],
      {
        queryParams: {
            login: login,
            returnurl: returnurl
        },
        replaceUrl: true
      }) : environment.backend.rsaaOAuth;

    window.location.href = url.toString();

    const authentication: DxAuthentication = new DxAuthentication();
    authentication.authResult = DxOperationResultType.SUCCESS;
    return of(authentication);

    // return this._http.get(this._configService.pitSessionStorageService + '/authme',
    //                {
    //                  params: new HttpParams().append('login', login).append('returnurl', returnurl),
    //                  headers: new HttpHeaders().append('Accept', 'application/json;charset=UTF-8'),
    //                  observe: 'response',
    //                  responseType: 'text',
    //                  withCredentials: true
    //                } as any as DxRequestOptions)
    //         .pipe(
    //            switchMap(response => {
    //              const authentication: DxAuthentication = new DxAuthentication();
    //              authentication.authResult = response.body.toString() == 'ok' ? DxOperationResultType.SUCCESS : DxOperationResultType.FAILED;
    //              //authentication.user = this.sessionService.currentSession
    //              return of(authentication);
    //            })
    // );
  }
}

